<script setup>
  import { ref, computed } from 'vue';
  import { ITEMS_LIST_MODULE_NAME, useStore } from "../plugins/store";

  const props = defineProps({
    value: String,
    onFocus: Function,
    isMobileStructureActive: Boolean
  });
  const emit = defineEmits(['input', 'close', 'focus']);

  //region INPUT MANAGEMENT
  const previousValue = ref();
  const onInput = (event) => {
    if (!previousValue.value || event.target.value.trim() !== previousValue.value.trim()) {
      emit('input', event.target.value);
    }
    previousValue.value = event.target.value;
  }
  //endregion

  //region CLOSE
  const showCloseIcon = computed(() => props.value !== '');
  const onCloseClick = () => {
    emit('close');
  }
  //endregion

  //region FOCUS
  const onFocus = () => emit('focus');
  //endregion

  //region KEYBOARD ACTIONS
  const onArrowUp = () => useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/navigatePreviousIndex');
  const onArrowDown = () => useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/navigateNextIndex');
  const onEnter = () => useStore().dispatch(ITEMS_LIST_MODULE_NAME + '/openItem');
  //endregion
</script>

<template>
  <form :class="{'mobile-structure': props.isMobileStructureActive}">
    <div class="form-container-input">
      <div class="d-flex align-items-center form-search-zone">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25">
          <path fill="#565B60" fill-rule="evenodd" d="M16.6 17.26a8 8 0 1 1 1.07-1.05l3.61 3.61a.75.75 0 0 1-1.06 1.06l-3.62-3.62Zm1.43-6.2a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z" clip-rule="evenodd"/>
        </svg>
        <input
            class="form-control"
            type="text"
            :placeholder="$t('search.tree-view.search.terminology')"
            name="text"
            autocomplete="off"
            :value="props.value"
            @input="onInput($event)"
            @focus="onFocus()"
            @keyup.up.prevent="onArrowUp()"
            @keydown.up.prevent
            @keyup.down.prevent="onArrowDown()"
            @keydown.down.prevent
            @keyup.enter.prevent="onEnter()"
            @keydown.enter.prevent
        >
      </div>
      <div v-if="showCloseIcon" class="container-svg-close" @click="onCloseClick()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17">
          <path fill="#565B60" fill-rule="evenodd" d="M3.8 3.36a1 1 0 0 1 1.4 0l3.3 3.3 3.3-3.3a1 1 0 1 1 1.4 1.41l-3.29 3.3 3.3 3.29a1 1 0 0 1-1.42 1.41L8.5 9.48l-3.3 3.3a1 1 0 0 1-1.4-1.42l3.29-3.3-3.3-3.29a1 1 0 0 1 0-1.41Z" clip-rule="evenodd"/>
        </svg>
      </div>
    </div>
  </form>
</template>

<style scoped lang="scss">
@import '../../../../../assets/css/theme/helpers/variables';

form {

  .form-container-input:focus-within {
    border-color: $input-focus-border-color;
  }

  .form-container-input {
    width: 100%;
    height: 42px;
    padding: 6px 5px 6px 10px;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    border: 1px solid $input-border-color;
    display: flex;
    justify-content: space-between;

    .form-search-zone {
      width: 100%;
    }

    svg {
      width: 27px;
      height: 24px;
      display: inline-block;
      float: left;
      margin-right: 6px;
    }

    .container-svg-close {
      display: flex;
      height: 100%;
      cursor: pointer;
      border-radius: 20px;
      padding: 4px;
      width: 33px;

      svg {
        width: 16px;
        height: 16px;
        margin: auto;
      }
      &:hover {
        background-color: $icon-accordion;
      }
    }


    input {
      border: none;
      outline: none;
      width: 100%;
      float: left;
      font-size: 14px;
    }
  }
}

@media (max-width: 992px) {
  form.mobile-structure {
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 0;
  }
}
</style>
